<template>
  <div class="parent " id="card-cycle">
    <div :class="'img-active'">
      <carousel-3d :width="getWidth" :height="getHeight" border="0" ref="mycarousel" :controlsVisible="true" @after-slide-change="onSlideChange" @before-slide-change="onSlideChange">
        <slide :index="0">
          <img
            src="@/assets/images/bank-card-gold.png"
            alt=""
            srcset=""
            id="gold-card-image"
            :class="[
              'img-cards-default',
              { 'img-active': activeCard == 'Gold' },
            ]"
            @click="setActive('Gold')"
          />
        </slide>
        <slide :index="1">
          <img
            src="@/assets/images/bank-card-platinum.png"
            alt=""
            srcset=""
            id="platinum-card-image"
            :class="[
              'img-cards-default',
              { 'img-active': activeCard == 'Platinum' },
            ]"
            @click="setActive('Platinum')"
          />
        </slide>
        <slide :index="2">
          <img
            src="@/assets/images/bank-card-black.png"
            alt=""
            srcset=""
            id="black-card-image"
            :class="[
              'img-cards-default',
              { 'img-active': activeCard == 'Black' },
            ]"
            @click="setActive('Black')"
          />
        </slide>
        <slide :index="3">
          <img
            src="@/assets/images/bank-card-purple.png"
            alt=""
            srcset=""
            id="purple-card-image"
            :class="[
              'img-cards-default',
              { 'img-active-purple': activeCard == 'Purple' },
            ]"
            @click="setActive('Purple')"
          />
        </slide>
      </carousel-3d>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeCard: {
      default: "Black",
    },
  },
  data() {
    return {
      active: this.activeCard,
    };
  },
  methods: {
    setActive(item) {
      this.$emit("active", item);
    },
    onSlideChange(index) {
      
      this.setActive(this.indexValue(index))
    },

showActive(){

   switch(this.activeCard){
     case 'Gold':
       return 0
     case 'Platinum':
       return 1
     case 'Black':
       return 2
     case 'Purple':
       return 3
   }
},
indexValue(i){
switch(i){
  case 0:
    return "Gold";
  case 1:
    return "Platinum";
  case 2:
    return "Black";
  case 3:
    return "Purple";
}
}
  },
  computed: {

    getWidth() {
      let x = window.innerWidth;
    
      return  x > 500
        ? 200
        : 120;
    },
    getHeight(){
      let x = window.innerWidth;
      return  x > 500
        ? 270
        : 162;
    }
  },
  mounted(){

      this.$refs.mycarousel.goSlide(this.showActive())
    
  }
};
</script>

<style lang="scss" scoped>
.img-cards-default {
  height: 100%;
  cursor: pointer;
}

// #gold-card-image {
//   &:hover {
//     height: 14em;
//   }
// }
// #purple-card-image {
//   &:hover {
//     height: 14em;
//   }
// }
// #black-card-image {
//   &:hover {
//     height: 14em;
//   }
// }
// #platinum-card-image {
//   &:hover {
//     height: 14em;
//   }
// }
// .img-active-Gold {
//   position: relative;
//   #gold-card-image {
//     height: 16em !important;
//     position: relative;
//     left: 4em;
//     z-index: 5;
//   }
//   #platinum-card-image {
//     height: 13em !important;
//     position: relative;
//     left: 2em;
//     z-index: 4;
//   }
//   #black-card-image {
//     height: 12em !important;
//     position: relative;
//     left: 0em;
//     z-index: 3;
//   }
//   #purple-card-image {
//     height: 10em !important;
//     position: inherit;
//     left: -1em;
//     z-index: 2;
//   }
// }

// .img-active-Platinum {
//   position: relative;
//   #gold-card-image {
//     height: 13em !important;
//     position: relative;
//     left: 2em;
//     z-index: 4;
//   }
//   #platinum-card-image {
//     height: 16em !important;
//     position: relative;
//     z-index: 5;
//   }
//   #black-card-image {
//     height: 13em !important;
//     position: relative;
//     right: 2em;
//     z-index: 4;
//   }
//   #purple-card-image {
//     height: 12em !important;
//     position: relative;
//     right: 4em;
//     z-index: 3;
//   }
// }

// .img-active-Black {
//   #gold-card-image {
//     height: 12em !important;
//     position: relative;
//     left: 4em;
//     z-index: 3;
//   }
//   #platinum-card-image {
//     height: 13em !important;
//     position: relative;
//     left: 2em;
//     z-index: 4;
//   }
//   #black-card-image {
//     height: 16em !important;
//     position: relative;
//     z-index: 5;
//   }
//   #purple-card-image {
//     height: 13em !important;
//     position: relative;
//     right: 2em;
//     z-index: 4;
//   }
// }
// .img-active-Purple {
//   #gold-card-image {
//     height: 10em !important;
//     position: relative;
//     left: 6em;
//     z-index: 4;
//   }
//   #platinum-card-image {
//     height: 12em !important;
//     position: relative;
//     left: 4em;
//     z-index: 4;
//   }
//   #black-card-image {
//     height: 13em !important;
//     position: relative;
//     left: 2em;
//     z-index: 4;
//   }
//   #purple-card-image {
//     height: 16em !important;
//      position: relative;
//     z-index: 5;
//   }
// }
</style>